import { render, staticRenderFns } from "./DeliverableTypeIcon.vue?vue&type=template&id=0c11c695&"
import script from "./DeliverableTypeIcon.vue?vue&type=script&lang=js&"
export * from "./DeliverableTypeIcon.vue?vue&type=script&lang=js&"
import style0 from "./DeliverableTypeIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c11c695')) {
      api.createRecord('0c11c695', component.options)
    } else {
      api.reload('0c11c695', component.options)
    }
    module.hot.accept("./DeliverableTypeIcon.vue?vue&type=template&id=0c11c695&", function () {
      api.rerender('0c11c695', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/DeliverableTypeIcon.vue"
export default component.exports